export const uk = {
    experimentsArchive: '{experimentsArchiveName} - архив'
};
